var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dc" },
    [
      _vm.$store.getters.authUser.userType == 1
        ? [
            _vm.step == "info"
              ? _c(
                  "div",
                  { staticClass: "row step" },
                  [
                    !_vm.$utils.isEmptyObj(_vm.certApply) &&
                    _vm.certApply.applyStatus != 2
                      ? [
                          _vm.certApply.applyStatus == 0
                            ? [
                                _vm.certApply.ifApi == 0
                                  ? _c("div", {}, [
                                      _c("img", {
                                        attrs: {
                                          src: "/images/u10.jpg",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(
                                        "\n            您的API商户已为您申请君子盾，但须验证对公账户。\n            "
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-primary margin-large-t",
                                          attrs: {
                                            type: "button",
                                            id: "addCert"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.step = "validate"
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              立即验证对公账户\n            "
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.certApply.ifApi == 1
                                  ? [_vm._m(0)]
                                  : _vm._e()
                              ]
                            : _vm._e(),
                          _vm.certApply.applyStatus == 1
                            ? [
                                _vm._m(1),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-5" },
                                  [
                                    _vm._v(
                                      "\n            恭喜，您已获得君子盾。\n            "
                                    ),
                                    _c("br"),
                                    _vm._v("类型：\n            "),
                                    _vm.certApply.userType == 0
                                      ? [_vm._v("软证书")]
                                      : _vm._e(),
                                    _vm.certApply.userType == 1
                                      ? [_vm._v("硬key")]
                                      : _vm._e(),
                                    _c("br"),
                                    _vm._v(
                                      "序列号：" +
                                        _vm._s(_vm.certApply.icnumber) +
                                        "\n            "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "申请时间：" +
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            _vm.certApply.createTime
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "发放时间：" +
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            _vm.certApply.updateTime
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "有效期：" +
                                        _vm._s(_vm.certApply.validity) +
                                        "天\n            "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "有效期至：" +
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            _vm.certApply.expireTime
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ],
                                  2
                                )
                              ]
                            : _vm._e()
                        ]
                      : [
                          _c("div", { staticClass: "product-page" }, [
                            _c("img", {
                              attrs: { src: "/images/u10.jpg", alt: "" }
                            }),
                            _vm._m(2),
                            _c(
                              "a",
                              {
                                staticClass: "bg-success btn",
                                attrs: { href: "javascript:void (0)" },
                                on: {
                                  click: function($event) {
                                    _vm.step = "pay"
                                  }
                                }
                              },
                              [_vm._v("不联系，自主申请")]
                            )
                          ])
                        ]
                  ],
                  2
                )
              : _vm._e(),
            _vm.step == "pay"
              ? [
                  _c(
                    "el-form",
                    {
                      staticClass: "pay-form",
                      attrs: { size: "small", "label-width": "390px" }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "300px" } },
                        [
                          _c("h4", { staticClass: "color-success" }, [
                            _vm._v("付款和邮寄地址")
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "300px" } },
                        [
                          _c("p", [
                            _vm._v("付款购买君子盾，"),
                            _c("span", { staticClass: "color-danger" }, [
                              _vm._v(
                                "君子盾硬key的邮寄地址以申请表填写的为准。"
                              )
                            ])
                          ])
                        ]
                      ),
                      _c("el-form-item", { attrs: { label: "应付金额：" } }, [
                        _c("p", [_vm._v("300.00元")])
                      ]),
                      _c("el-form-item", { attrs: { label: "付款方式：" } }, [
                        _c("p", [_vm._v("对公账户汇款")])
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "申请表扫描件：" } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: "",
                                      placeholder: "请选择申请书扫描件",
                                      value: _vm.file ? _vm.file.name : ""
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("el-col", { attrs: { span: 10, offset: 1 } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "upload-copy",
                                    staticStyle: { position: "relative" }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "btn",
                                        attrs: { type: "danger" }
                                      },
                                      [_vm._v("选择文件")]
                                    ),
                                    _c("input", {
                                      staticStyle: {
                                        display: "block",
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        top: "0px",
                                        left: "0px",
                                        "z-index": "999"
                                      },
                                      attrs: { type: "file" },
                                      on: {
                                        change: function($event) {
                                          return _vm.chooseFile($event)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "a",
                                  {
                                    staticStyle: { "vertical-align": "top" },
                                    attrs: { href: "/君子盾申请表.doc" }
                                  },
                                  [_vm._v("申请表模板下载")]
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "300px" } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 9 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn__submit",
                                      attrs: { type: "success" },
                                      on: {
                                        click: function($event) {
                                          return _vm.payFrmSubmit()
                                        }
                                      }
                                    },
                                    [_vm._v("提交并付款")]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 4, offset: 1 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-cancle",
                                      on: {
                                        click: function($event) {
                                          _vm.step = "info"
                                        }
                                      }
                                    },
                                    [_vm._v("取消")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm.step == "validate"
              ? [
                  true
                    ? _c("div", { staticClass: "box" }, [
                        _vm._m(3),
                        _c("p", [
                          _vm._v(
                            "\n          通过银行系统完成身份验证，确保企业身份的真实性；请在10个工作日内使用对公账户向君子签完成指定金额的汇款，以便完成验证。\n        "
                          )
                        ]),
                        _c("table", { staticClass: "table table-bordered" }, [
                          _vm._m(4),
                          _vm._m(5),
                          _vm._m(6),
                          _vm._m(7),
                          _c("tr", [
                            _vm._m(8),
                            _c("td", [
                              !_vm.$utils.isEmptyObj(_vm.certApply) &&
                              _vm.certApply.applyStatus == 0
                                ? _c("span", { attrs: { id: "randomYuan" } }, [
                                    _vm._v(_vm._s(_vm.certApply.randomMoney))
                                  ])
                                : _vm._e(),
                              _vm._v("元\n              "),
                              _c("span", { staticClass: "color-danger" }, [
                                _vm._v("（非指定金额将会验证失败）")
                              ])
                            ])
                          ]),
                          _vm._m(9)
                        ])
                      ])
                    : _vm._e()
                ]
              : _vm._e()
          ]
        : [
            _c(
              "div",
              { staticStyle: { height: "300px", "line-height": "300px" } },
              [_vm._v("\n      个人用户君子盾功能还在开发中！\n    ")]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("h4", { staticClass: "color-success" }, [_vm._v("对公账户付款")]),
      _c("p", [
        _c("span", { staticClass: "color-danger" }, [
          _vm._v("请务必使用贵公司对公账户完成付款。")
        ]),
        _vm._v(
          " 请在10个工作日内使用对公账户向君子签完成指定金额的汇款，以便完成君子盾的购买。"
        )
      ]),
      _c("table", [
        _c("tbody", [
          _c("tr", [
            _c("td", [_c("b", [_vm._v("开户名")])]),
            _c("td", [_vm._v("重庆君子签科技有限公司")])
          ]),
          _c("tr", [
            _c("td", [_c("b", [_vm._v("对公账户")])]),
            _c("td", [_vm._v("3108 1401 0400 0058 2")])
          ]),
          _c("tr", [
            _c("td", [_c("b", [_vm._v("开户行")])]),
            _c("td", [_vm._v("农业银行")])
          ]),
          _c("tr", [
            _c("td", [_c("b", [_vm._v("开户地点")])]),
            _c("td", [_vm._v("重庆两江星光支行")])
          ]),
          _c("tr", [
            _c("td", [_c("b", [_vm._v("指定金额")])]),
            _c("td", [_vm._v("300元")])
          ]),
          _c("tr", [
            _c("td", [_c("b", [_vm._v("汇款备注")])]),
            _c("td", [_vm._v("购买CA")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-4 text-right" }, [
      _c("img", { attrs: { src: "/images/u10.jpg", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n            君子盾是您签署的身份凭证之一，同时您将拥有独一无二无可仿冒的"
      ),
      _c("b", [_vm._v("数字签名")]),
      _vm._v("。"),
      _c("br"),
      _c("br"),
      _vm._v("\n            申请君子盾后，只能在安装了"),
      _c("b", [_vm._v("软证书")]),
      _vm._v("或者插有"),
      _c("b", [_vm._v("硬key")]),
      _vm._v("的电脑才能完成电子签署。"),
      _c("br"),
      _vm._v(
        "\n            当您更换电脑或重装系统时，需要重新安装君子盾控件。\n            "
      ),
      _c("a", { attrs: { href: "@/asset/君子盾控件.exe" } }, [
        _vm._v("点此安装君子盾控件")
      ]),
      _vm._v("（强烈建议关闭杀毒软件）请联系您的API商户为您申请。\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _c("b", { staticClass: "color-success" }, [_vm._v("对公账户验证")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_c("b", [_vm._v("开户名")])]),
      _c("td", [_vm._v("重庆君子签科技有限公司")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_c("b", [_vm._v("对公账户")])]),
      _c("td", [_vm._v("3108 1401 0400 0058 2")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_c("b", [_vm._v("开户行")])]),
      _c("td", [_vm._v("农业银行")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_c("b", [_vm._v("开户地点")])]),
      _c("td", [_vm._v("重庆两江星光支行")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("指定金额")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_c("b", [_vm._v("汇款备注")])]),
      _c("td", [_vm._v("对公验证")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfb2a1d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfb2a1d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/signSettings/security/dc.vue
// module id = cNLx
// module chunks = 219